import React from 'react';
import { C, font, serif, btnStyle, btnHoverEnter, btnHoverLeave } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';

const PROJECTS = [
  {
    initials: 'GA', name: 'Talabartería GA', sub: 'Artesanía · Jocotitlán',
    mundo: 'MUNDO 03', era: 'Era 1 · Existencia', pct: 34,
    star: '★ Cinturón piteado · $1,200',
    note: '"Puse precio por la piel, no por el trabajo. Ya lo corregí."',
    badges: '3 insignias · 11 pines', color: C.mango, salud: 62,
  },
  {
    initials: 'R', name: 'Rústico', sub: 'Alimentos · Restaurante',
    mundo: 'MUNDO 04', era: 'Era 2 · Supervivencia', pct: 48,
    star: '★ Parrillada para dos · $620',
    note: '"Las reservas por WhatsApp subieron cuando pusimos el menú en Maps."',
    badges: '4 insignias · 16 pines', color: C.turquesa, salud: 78,
  },
  {
    initials: 'TÚ', name: 'Tu negocio', sub: 'Tu giro · Tu ciudad',
    mundo: 'MUNDO 00', era: 'Empieza hoy', pct: 0,
    star: null,
    note: 'Tu primer aprendizaje aparecerá aquí.',
    badges: null, color: C.coral, isCta: true, salud: null,
  },
];

export default function SeccionProyectos({ isMobile, isTablet, onStart }) {
  const reveal = useScrollReveal();
  const mob = isMobile;

  return (
    <section
      id="proyectos"
      ref={reveal.ref}
      style={{
        maxWidth: 1180, margin: '0 auto',
        padding: mob ? '2.5rem 1rem' : '4rem 1.5rem',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      {/* Header */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
        gap: 24, flexWrap: 'wrap', marginBottom: 28,
      }}>
        <div style={{ maxWidth: 700 }}>
          <p style={{
            fontSize: mob ? 11 : 12, letterSpacing: 3, fontWeight: 700,
            textTransform: 'uppercase', color: C.turquesa, margin: '0 0 14px',
          }}>02 · Proyectos de emprendedores</p>
          <h2 style={{
            fontFamily: serif, fontSize: mob ? 28 : isTablet ? 36 : 48,
            fontWeight: 400, lineHeight: 1, margin: '0 0 16px', color: '#fff',
          }}>
            Mira dónde van otros <em style={{ color: C.turquesa, fontStyle: 'italic' }}>y cómo llegaron.</em>
          </h2>
          <p style={{ fontSize: mob ? 15 : 17, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, margin: 0 }}>
            Cada negocio tiene una carta: su producto estrella, su mundo actual, sus insignias y lo que ha aprendido.
            Encuentra a quien va un paso adelante de ti y a quien piensa como tú.
          </p>
        </div>
        {!mob && (
          <button
            onClick={onStart}
            style={{
              background: 'transparent', border: `1px solid ${C.border}`,
              borderRadius: 999, padding: '0 22px', height: 46, fontWeight: 700,
              fontSize: 15, color: '#fff', cursor: 'pointer', fontFamily: font,
              flexShrink: 0,
            }}
          >Ver todos los proyectos</button>
        )}
      </div>

      {/* Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: mob ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(3, 1fr)',
        gap: 20,
      }}>
        {PROJECTS.map((p, i) => (
          <div key={i} style={{
            background: 'rgba(255,255,255,0.04)',
            border: `2px solid ${p.color}`,
            borderRadius: 20, padding: 24,
            display: 'flex', flexDirection: 'column', gap: 12,
            transition: 'transform 0.4s cubic-bezier(.16,1,.3,1), box-shadow 0.4s',
          }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = `0 20px 50px rgba(${hexRgb(p.color)}, 0.25)`;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {/* Top: avatar + name + tag */}
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{
                width: 52, height: 52, borderRadius: 12,
                background: 'rgba(255,255,255,0.06)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 800, color: p.color, fontSize: p.initials.length > 2 ? 11 : 14,
                transition: 'transform 0.4s cubic-bezier(.16,1,.3,1)',
              }}>{p.initials}</div>
              <div style={{ flex: 1 }}>
                <strong style={{ fontSize: 15, color: '#fff', display: 'block' }}>{p.name}</strong>
                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', display: 'block' }}>{p.sub}</span>
              </div>
              <span style={{
                fontSize: 11, padding: '4px 10px', borderRadius: 999,
                background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)', fontWeight: 700,
              }}>{p.mundo}</span>
            </div>

            {/* Progress bar */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
              <span>{p.era}</span><span>{p.pct}%</span>
            </div>
            <div style={{ height: 8, borderRadius: 4, background: 'rgba(255,255,255,0.08)' }}>
              <div style={{ width: `${p.pct}%`, height: '100%', borderRadius: 4, background: p.color }} />
            </div>

            {/* Salud administrativa */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 10, letterSpacing: 1.5, color: 'rgba(255,255,255,0.4)', fontWeight: 700, flexShrink: 0 }}>SALUD ADMIN.</span>
              <div style={{ flex: 1, height: 5, borderRadius: 3, background: 'rgba(255,255,255,0.08)' }}>
                <div style={{ width: p.salud != null ? `${p.salud}%` : '0%', height: '100%', borderRadius: 3, background: C.turquesa }} />
              </div>
              <span style={{ fontSize: 11, fontWeight: 700, color: p.salud != null ? C.turquesa : 'rgba(255,255,255,0.25)', minWidth: 20, textAlign: 'right' }}>
                {p.salud != null ? p.salud : '—'}
              </span>
            </div>

            {/* Star product */}
            <span style={{ fontSize: 10, letterSpacing: 1.5, color: 'rgba(255,255,255,0.4)', fontWeight: 700 }}>PRODUCTO ESTRELLA</span>
            <span style={{ fontSize: 14, color: p.star ? '#fff' : 'rgba(255,255,255,0.4)' }}>
              {p.star || 'Tu producto estrella aquí'}
            </span>

            {/* Last learning */}
            <span style={{ fontSize: 10, letterSpacing: 1.5, color: 'rgba(255,255,255,0.4)', fontWeight: 700 }}>ÚLTIMO APRENDIZAJE</span>
            <span style={{ fontSize: 13, fontStyle: 'italic', color: 'rgba(255,255,255,0.55)' }}>{p.note}</span>

            {/* Footer */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 700, marginTop: 'auto' }}>
              {p.badges ? (
                <>
                  <span style={{ color: C.mango }}>{p.badges}</span>
                  <span style={{ color: C.turquesa }}>Ver carta →</span>
                </>
              ) : (
                <span style={{ color: p.color, cursor: 'pointer' }} onClick={onStart}>Crea tu carta gratis →</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function hexRgb(hex) {
  const h = hex.replace('#', '');
  return `${parseInt(h.substring(0,2),16)},${parseInt(h.substring(2,4),16)},${parseInt(h.substring(4,6),16)}`;
}
